import React, { useState } from 'react';
import {
  Box,
  Typography,
  useTheme,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  keyframes,
} from '@mui/material';
import { MessageCircle, X } from 'lucide-mui';

const pulse = keyframes`
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.9;
  }
  100% {
    opacity: 0.6;
  }
`;

const ChatEmpty = () => {
  const theme = useTheme();
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => setDialogOpen(true);
  const handleCloseDialog = () => setDialogOpen(false);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        flexGrow: 1,
        height: '80%',
        m: 2,
        gap: theme.spacing(2),
      }}
    >
      <MessageCircle
        sx={{
          fontSize: 48,
          color: theme.palette.text.secondary,
          opacity: 0.9,
          animation: `${pulse} 2s ease-in-out infinite`,
        }}
      />
      <Typography
        variant="h6"
        sx={{
          fontWeight: 500,
          color: theme.palette.text.primary,
        }}
      >
        Ask AI will be ready soon
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.text.secondary,
          maxWidth: '400px',
        }}
      >
        You will be able to chat with your recording once the transcription is
        complete.
      </Typography>
      <Button variant="outlined" color="secondary" onClick={handleOpenDialog}>
        Learn More
      </Button>

      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            m: 2,
          },
        }}
      >
        <DialogTitle
          sx={{
            pr: 6,
            pb: 1,
          }}
        >
          About Ask AI
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            }}
          >
            <X />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Ask AI is an intelligent assistant that helps you instantly get
            answers about your video content. Once your video is transcribed,
            you can:
          </Typography>
          <Box
            component="ul"
            sx={{
              mt: 2,
              pl: 2,
              '& li': {
                mb: 1,
              },
            }}
          >
            <Typography component="li">
              Ask questions and get immediate answers with exact timestamps
            </Typography>
            <Typography component="li">
              Get quick summaries and key points
            </Typography>
            <Typography component="li">
              Search for specific topics or moments in the video
            </Typography>
            <Typography component="li">
              Jump directly to relevant parts of the video
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 1 }}>
          <Button
            onClick={handleCloseDialog}
            variant="contained"
            color="primary"
            sx={{ minWidth: 100 }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ChatEmpty;
